import {
  ActionIcon,
  Group,
  Menu,
  SegmentedControl,
  Stack,
  Text,
} from "@mantine/core";
import {
  Link,
  useNavigate,
  useParams,
  useRouteLoaderData,
} from "react-router-dom";
import CommunityDropdown from "./CommunityDropdown";
import {
  IconDotsVertical,
  IconExternalLink,
  IconSettings,
  IconUsers,
} from "@tabler/icons-react";
import { downloadExtension } from "../../../../api/ResellerAPI";
import ResellerUsers from "./ResellerUsers";
import ResellerSettings from "./ResellerSettings";
import CreateUser from "../../resellers/createUser/CreateUserButton";
import { useLanguage } from "../../../../stores/LanguageStore";

const ResellerPage = () => {
  const lang = useLanguage((s) => s.language);
  const reseller = useRouteLoaderData("reseller");
  const { tab } = useParams();
  const navigate = useNavigate();
  
  return (
    <Stack gap={0} pr={48} pt={32} px={64}>
      <Group>
        <CommunityDropdown
          getClickLink={(id) => `/resellers/${id}`}
          getDeletedLink={(id) => `/resellers/`}
        />

        <ActionIcon
          component={Link}
          to={`https://${reseller?.domain_saas3 || reseller?.domain_saas2}`}
          target="_blank"
          variant="light"
          size={"lg"}
          onClick={(e) => e.stopPropagation()}
          disabled={!reseller?.domain_saas3 && !reseller?.domain_saas2}
        >
          <IconExternalLink size={24} />
        </ActionIcon>

        <Menu>
          <Menu.Target variant="subtle" size={"lg"}>
            <ActionIcon>
              <IconDotsVertical size={24} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item
              component={Link}
              to={`/resellers/${reseller.id}/settings`}
            >
              {lang.white_labels.edit_label}
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                downloadExtension({
                  id: reseller.id,
                  name: `${reseller.name} - Chrome extension`,
                });
              }}
            >
              {lang.white_labels.download_ext}
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>

        <SegmentedControl
          w={500}
          mx={"auto"}
          size="md"
          value={tab}
          data={[
            {
              label: (
                <Group justify="center">
                  <IconUsers />

                  <Text>{lang.white_labels.users}</Text>
                </Group>
              ),
              value: "users",
            },
            {
              label: (
                <Group justify="center">
                  <IconSettings />

                  <Text>{lang.white_labels.settings}</Text>
                </Group>
              ),
              value: "settings",
            },
          ]}
          onChange={(v) => {
            navigate(`/resellers/${reseller.id}/${v}`);
          }}
        />

        <CreateUser parentUrl={`/resellers/${reseller.id}/`} />
      </Group>

      {tab === "users" ? <ResellerUsers /> : <ResellerSettings />}
    </Stack>
  );
};

export default ResellerPage;
